import { render, staticRenderFns } from "./MessageInconsistencyAlert.vue?vue&type=template&id=58c52d2e"
import script from "./MessageInconsistencyAlert.vue?vue&type=script&lang=js"
export * from "./MessageInconsistencyAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports